/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React               from 'react';
import PropTypes           from 'prop-types';
import { Header }          from '../../organisms/Header';
import { StyledMain }      from '../../atoms/StyledMain';
import { Footer }          from '../../organisms/Footer';
import { Avatar }          from '../../atoms/Avatar';
import { Logo }            from '../../molecules/Logo';
import { StyledContainer } from '../../atoms/StyledContainer'


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const DefaultPage = ({ children }) => (
    <StyledContainer>
        <Header>
            <Logo>
                <Avatar/>
            </Logo>
        </Header>
        <StyledMain>{children}</StyledMain>
        <Footer/>
    </StyledContainer>
);


DefaultPage.propTypes = {
    children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/templates/DefaultPage/index.js